export const ActionTypes = {
    // product
    SET_PRODUCTS: "SET_PRODUCTS",
    SET_SELECTED_PRODUCT: "SET_SELECTED_PRODUCT",
    SET_SELECTED_ARTICLE : "SET_SELECTED_ARTICLE",
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    SET_FAVORITES:"SET_FAVORITES",
    // category
    SET_CATEGORIES: "SET_CATEGORIES",
    // user
    SET_USER: "SET_USER",
    SET_PRODUCT_USER_DETAIL:"SET_PRODUCT_USER_DETAIL",
    // settings
    SET_SETTINGS: "SET_SETTINGS",
    // others
    SET_CURRENCIES: "SET_CURRENCIES",
    SET_REGIONS: "SET_REGIONS",
    SET_CITIES: "SET_CITIES",
    SET_DISTRICTS: "SET_DISTRICTS",
    SET_CATEGORY_PRODUCTS:"SET_CATEGORY_PRODUCTS",
    SET_PLANS:"SET_PLANS",
    SET_BUSSINESS_PLAN_DETAILS:"SET_BUSSINESS_PLAN_DETAILS"
};